<template>
    <div v-if="disabled" style="position: relative;">
        <div class="block-ui"></div>
        <slot />
    </div>
    <div v-else>
        <slot />
    </div>
</template>
<script setup>
defineProps({
    disabled: {
        type: Boolean,
        default: () => (false)
    }
})
</script>
<style scope>
.block-ui {
    border-radius: 0.2rem;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 1101 !important;
    pointer-events: none;
    background-clip: border-box;
    background-color: rgba(0, 0, 0, 0.4);
    background-image: none;
    background-origin: padding-box;
    background-position-x: 0%;
    background-position-y: 0%;
    background-repeat: repeat;
    background-size: auto;
    background-attachment: scroll;
}
</style>